import { htmlSafe } from '@ember/template';
import Helper from '@ember/component/helper';

export function formatMoney([value], options = {}) {
  if (options.format === 'en-US') {
    value = value ? value : 0;

    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
    });

    return formatter.format(value).replace(/\D00$/, '');
  }

  if (value === null) {
    return '--';
  }

  let prefix = '';
  let suffix = '';
  if (value < 0 && !options.noPrefix) {
    if (options.crAfterAmount) {
      suffix = ' CR';
    } else {
      prefix = 'CR ';
    }
  }

  let formattedValue = applyPrecision(Math.abs(value), options.precision);
  let formatted = `${prefix}$${formattedValue}${suffix}`;

  if (options.isPayment) {
    formatted = htmlSafe(`<span class="muted">(${formatted})</span>`);
  }

  return formatted;
}

function applyPrecision(value, precision) {
  if (precision === undefined || precision === null) {
    return value;
  }

  const rounded = Math.round(value * 10 ** precision) / 10 ** precision;
  return rounded % 1 === 0 ? value : value.toFixed(precision);
}

export function convertToCents(amount) {
  return Math.round(amount * 100);
}

export function roundToCurrency(amount) {
  return Math.round(amount * 100) / 100;
}

export default Helper.helper(formatMoney);
